const REQUEST_SETTINGS = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_SETTINGS = (state, { body }) => {
  state.Settings = body;
  state.status = "success";
};

const FAILURE_REQUEST_SETTINGS = state => {
  state.status = "failure";
};

const REQUEST_DELETE_SETTING = state => {
  state.statusDelete = "fetching";
};

const SUCCESS_REQUEST_DELETE_SETTING = state => {
  state.statusDelete = "success";
};

const FAILURE_REQUEST_DELETE_SETTING = state => {
  state.statusDelete = "failure";
};

const REQUEST_UPDATE_SETTING = (state) => {
  
  state.statusUpdate = "fetching";
};

const SUCCESS_REQUEST_UPDATE_SETTING = state => {
  state.statusUpdate = "success";
};

const FAILURE_REQUEST_UPDATE_SETTING = state => {
  state.statusUpdate = "failure";
};

const REQUEST_CREATE_SETTING = state => {
  state.statusCreate = "fetching";
};

const SUCCESS_REQUEST_CREATE_SETTING = (state, { body }) => {
  state.Setting = body;
  state.statusCreate = "success";
};

const FAILURE_REQUEST_CREATE_SETTING = state => {
  
  state.statusCreate = "failure";
};


export default {
  REQUEST_SETTINGS,
  SUCCESS_REQUEST_SETTINGS,
  FAILURE_REQUEST_SETTINGS,
  REQUEST_CREATE_SETTING,
  SUCCESS_REQUEST_CREATE_SETTING,
  FAILURE_REQUEST_CREATE_SETTING,
  REQUEST_DELETE_SETTING,
  SUCCESS_REQUEST_DELETE_SETTING,
  FAILURE_REQUEST_DELETE_SETTING,
  REQUEST_UPDATE_SETTING,
  SUCCESS_REQUEST_UPDATE_SETTING,
  FAILURE_REQUEST_UPDATE_SETTING,

};
